module.exports = "<tb-voice-assistant-enrollment-react></tb-voice-assistant-enrollment-react>";